import '@syncfusion/ej2-react-inplace-editor/styles/inplace-editor/material.css';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { Col, Row } from 'react-bootstrap';

import DetailInfo from 'components/ProviderData/IpaAdministration/organisms/IpaAdministrationDetailView/IpaAdministrationDetailViewDetailInfo';
import styles from 'components/ProviderData/IpaAdministration/organisms/IpaAdministrationDetailView/IpaAdministrationDetailViewIPADetail.module.css';
import MainInfo from 'components/ProviderData/IpaAdministration/organisms/IpaAdministrationDetailView/IpaAdministrationDetailViewMainInfo';
import MsoDetails from 'components/ProviderData/IpaAdministration/organisms/IpaAdministrationDetailView/IpaAdministrationDetailViewMSODetails';
import DisabledWrapper from 'components/ProviderData/utils/DisabledWrapper';
import 'components/ProviderData/IpaAdministration/organisms/IpaAdministration.css';

type IpaAdministrationDetailViewIPADetailProps = {
    ipa: Record<string, any>;
    setIpa: (newIpa?: Record<string, any>) => void;
    mso: Record<string, any>;
    fetchMso: any;
    isReadOnlyViewer: boolean;
    onClickContractInfo: any;
    saveContractInformation: any;
    contractInfoForm: any;
    getContractInfoValues: any;
    contracts: Record<string, any>;
    setContractInfoValue: any;
    fetchContracts: any;
    editFlag: any;
    errors: Record<string, any>;
    risks: Record<string, any>;
    types: Record<string, any>;
    onFiltering: any;
    sortOrder: string;
    query: Record<string, any>;
    vendors: Record<string, any>;
    fields: Record<string, any>;
    companyCodes: Record<string, any>;
    termed: string | undefined;
    copyToNewRecord: any;
    isDirty: boolean;
};

const IpaAdministrationDetailViewIPADetail = (props: IpaAdministrationDetailViewIPADetailProps) => {
    return (
        <DisabledWrapper disabled={props?.isReadOnlyViewer}>
            <div className='tab-content tabDiv p-3'>
                <form onSubmit={props?.onClickContractInfo(props?.saveContractInformation)}>
                    <div>
                        <p className='section-container-header'>
                            {props?.editFlag == true ? 'Edit Main Info' : 'Main Info'}{' '}
                        </p>
                        <MainInfo
                            ipa={props?.ipa}
                            setIpa={props?.setIpa}
                            contractInfoForm={props?.contractInfoForm}
                            getContractInfoValues={props?.getContractInfoValues}
                            setContractInfoValue={props?.setContractInfoValue}
                            editFlag={props?.editFlag}
                            errors={props?.errors}
                            risks={props?.risks}
                            types={props?.types}
                        />
                    </div>
                    <Row>
                        <Col md={6}>
                            <Row className={styles['container-row']}>
                                <Col
                                    className='field-col'
                                    md={12}
                                >
                                    <div className={`e-float-input e-input-group e-input-group-margin`}>
                                        <input
                                            type='text'
                                            {...props?.contractInfoForm('facetsCode', {
                                                maxLength: {
                                                    value: 60,
                                                    message: 'Facets Code must be maximum 60 characters length',
                                                },
                                            })}
                                            readOnly={props?.editFlag}
                                        />
                                        <span className='e-float-line'></span>
                                        <label className='e-float-text boldCss'>Facets Code</label>
                                    </div>
                                    {props?.errors?.facetsCode && (
                                        <div>
                                            <p className='error-form'>{props.errors.facetsCode.message}</p>
                                        </div>
                                    )}
                                </Col>
                            </Row>
                            <div className='fieldsets mt-4'>
                                <div className='subHeadding'>Vendor Info</div>
                                <div className='content'>
                                    <DetailInfo
                                        ipa={props?.ipa}
                                        contractInfoForm={props?.contractInfoForm}
                                        errors={props?.errors}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col md={6}>
                            <Row
                                className={`${props?.editFlag ? styles['no-edit-flag'] : styles['edit-flag']} ${
                                    styles['facets-code-row']
                                }`}
                            >
                                <Col
                                    className='field-col'
                                    md={8}
                                >
                                    <div className={styles['field-alignment']}>
                                        <label className={`${styles['contract-label']} e-label-select boldCss`}>
                                            Contract Name
                                        </label>
                                        <DropDownListComponent
                                            id='contractLevelId'
                                            {...props?.contractInfoForm('contractLevelId', {
                                                required: 'Contract Name is required',
                                            })}
                                            dataSource={props?.contracts}
                                            placeholder='Select a Contract Name'
                                            fields={{ value: 'id', text: 'text' }}
                                            value={String(props?.getContractInfoValues().contractLevelId)}
                                            change={({ itemData, value }) => {
                                                props?.setContractInfoValue('contractLevelId', Number(value));
                                                props?.setContractInfoValue('contractName', itemData.text);
                                                props?.fetchMso(itemData.id);
                                            }}
                                            popupHeight='220px'
                                            allowFiltering={true}
                                            readOnly={props?.editFlag}
                                        />
                                    </div>
                                    {props?.termed === 'Y' && (
                                        <span className='error-form'>The contract is termed</span>
                                    )}
                                    {props?.errors.contractName && (
                                        <span className='error-form'>{props?.errors.contractName.message}</span>
                                    )}
                                </Col>
                            </Row>
                            <div className={`${styles['contract-mso-container']} fieldsets  mt-4`}>
                                <div className='subHeadding'>Contract & MSO Info</div>
                                <div className={`${styles['contract-mso-content']} content`}>
                                    <MsoDetails
                                        mso={props?.mso}
                                        fetchMso={props?.fetchMso}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <div className={styles['buttons-bar']}>
                        {props?.ipa.id && (
                            <ButtonComponent
                                type='button'
                                onClick={() => props?.copyToNewRecord()}
                                cssClass='e-primary btn-primary'
                                className={styles['copy-button']}
                            >
                                Copy to New Record
                            </ButtonComponent>
                        )}
                        {!props?.editFlag && (
                            <ButtonComponent
                                cssClass='e-primary btn-primary btn-flat btn-create'
                                className={styles['save-button']}
                                disabled={!props?.isDirty}
                            >
                                Save
                            </ButtonComponent>
                        )}
                    </div>
                </form>
            </div>
        </DisabledWrapper>
    );
};

export default IpaAdministrationDetailViewIPADetail;
